import React from "react";
import Filterbars from "assets/icons/Filterbars";

const SortingOrder = ({ handleChange, value }) => {
  const handleChangeOrderType = () => {
    if (value === "DESC") {
      handleChange("orderType", "ASC");
    } else {
      handleChange("orderType", "DESC");
    }
  };
  return (
    <div
      style={{ padding: "10px 0", cursor: "pointer",marginLeft: "-32px" }}
      onClick={() => handleChangeOrderType()}
    >
      <Filterbars
        style={{
          ...(value === "ASC" && { transform: `rotate(180deg)` }),
        }}
      />
    </div>
  );
};

export default SortingOrder;
